import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'epay-creditcard-cancel',
  templateUrl: './creditcard-cancel.component.html'
})
export class CreditCardCancelComponent implements OnInit {
  pagetitle = "Credit Card Payment Cancelled";

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  GoToHomePage() {
    this.router.navigateByUrl('home');
  }

}
